// extracted by mini-css-extract-plugin
export default {"expandButtonWrapper":"TableModalWrapper_expandButtonWrapper__-QAth"};